export enum LangEnum {
  RU = 'ru',
  ENG = 'eng',
  ALL = 'all',
}
